import api from './index'

const userService = {
    getProfile: async () => {
        try {
            const res = await api.get('/api/v1/user/profile')
            return { data: res.data }
        } catch (error) {
            console.error('API call failed:', error)
            return { error: 'Failed to fetch profile' }
        }
    },
    updateProfile: async (profileData) => {
        try {
            const res = await api.put('/api/v1/user/profile', profileData)
            return { data: res.data }
        } catch (error) {
            console.error('API call failed:', error)
            return { error: 'Failed to update profile' }
        }
    },
}

export default userService
